<video
  #target
  class="video-js vjs-theme-city"
  playsinline
  [poster]="poster"
  preload="none"
></video>
